export default function TableFilters({ columnSchema = [], filters, onFilterChange }) {
  return (
    <div className="flex flex-wrap gap-4 p-2.5 bg-gray-100 rounded-md">
      {columnSchema.map(
        (col) =>
          col.filter && (
            <div key={col.id} className="flex flex-col gap-1 min-w-[100px]">
              <label className="text-xs font-medium text-gray-600">{col.label}</label>
              {col.filter === "search" && (
                <input
                  type="text"
                  value={filters[col.id] || ""}
                  onChange={(e) => onFilterChange(col.id, e.target.value)}
                  className="px-2 py-1 border bg-white border-gray-500 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400 text-sm"
                  placeholder={`Search ${col.label}`}
                />
              )}
              {col.filter === "select" && (
                <select
                  value={filters[col.id] || ""}
                  onChange={(e) => onFilterChange(col.id, e.target.value)}
                  className="px-2 py-1 border bg-white border-gray-500 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400 text-sm"
                >
                  <option value="">All</option>
                  {col.options?.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              )}
            </div>
          )
      )}
    </div>
  );
}
